import equal from 'fast-deep-equal/react';
import * as React from 'react';
import FrostAnimation from '~/customization/Frost/FrostAnimation';
import { RootState, useAppSelector } from '~/Store';
import { CategoryThemes } from '~/types/category';
import { getGlobalContent } from '~/utils/settings';

interface IAnimationDecorator {
    children: React.ReactChild | React.ReactChild[];
    mainColor?: string;
    isDisabled?: boolean;
}

const stateSelector = (state: RootState) => {
    return {
        currentPage: state.app.currentPage,
        categories: state.app.categories,
    };
};

export const THEMES_WITH_PERSONAL_ANIMATION: string[] = [];

const AnimationDecorator = ({ children, mainColor, isDisabled }: IAnimationDecorator) => {
    const { currentPage, categories } = useAppSelector(stateSelector, equal);
    const currentCategory = categories?.[currentPage?.name];
    const theme = THEMES_WITH_PERSONAL_ANIMATION?.includes(currentCategory?.theme) ? currentCategory.theme : getGlobalContent()?.theme;

    switch (theme) {
        case CategoryThemes.NY_THEME:
            return (
                <FrostAnimation mainColor={mainColor} isDisabled={isDisabled}>
                    {children}
                </FrostAnimation>
            );

        default:
            return <>{children}</>;
    }
};

export default AnimationDecorator;
